var map = {
	"./parachute 1.jpg": 45286,
	"./parachute.jpg": 2291,
	"./rat 1.jpg": 14330,
	"./rocket 01.jpg": 36347,
	"./rocket 2.jpg": 2142,
	"./rocket 3.jpg": 87099,
	"./rocket.jpg": 28132,
	"./stilite 2.jpg": 998,
	"./stilite 3.jpg": 39523,
	"./zirafee 1.jpg": 91131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61494;